import { LandingPage } from './LandingPage';
export default LandingPage;
export { Section as LandingPageSection, } from './components/Section';
export { ScreenShot as LandingPageScreenShot, } from './components/ScreenShot';
